import { useShouldShowIAFeature } from 'hooks/IAFeaturesHook';
export const useShouldShowIASummary = () => useShouldShowIAFeature('ai_summary');
